import { render, staticRenderFns } from "./veStuFile.vue?vue&type=template&id=5d8354c4&scoped=true"
import script from "./veStuFile.vue?vue&type=script&lang=js"
export * from "./veStuFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8354c4",
  null
  
)

export default component.exports